import { render } from "./IconLogo.vue?vue&type=template&id=05efccd5"
import script from "./IconLogo.vue?vue&type=script&lang=js"
export * from "./IconLogo.vue?vue&type=script&lang=js"
script.render = render

export default script